import React from 'react'
import LogoHeader from '../../components/LogoHeader'
import SignupForm from '../../components/Singup/SignupForm'

const Signup = () => {
  return (
    <>
      <LogoHeader />
      <SignupForm />
      {/* Login social */}
    </>
  )
}

export default Signup
